import { render, staticRenderFns } from "./ProductAverageCostList.vue?vue&type=template&id=e57209fc&"
import script from "./ProductAverageCostList.vue?vue&type=script&lang=js&"
export * from "./ProductAverageCostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e57209fc')) {
      api.createRecord('e57209fc', component.options)
    } else {
      api.reload('e57209fc', component.options)
    }
    module.hot.accept("./ProductAverageCostList.vue?vue&type=template&id=e57209fc&", function () {
      api.rerender('e57209fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-average-cost/ProductAverageCostList.vue"
export default component.exports